export type {
  FiltersWithMultiBadgesProps,
  MultiBadgeItem,
} from "./filters-with-multi-badges";
export { FiltersWithMultiBadges } from "./filters-with-multi-badges";
